function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.774 3.6l3.625 3.626c.801.801.801 2.1 0 2.9l-9.668 9.669c-.314.314-.72.517-1.16.58l-4.23.604c-1.121.16-2.16-.619-2.32-1.74-.028-.193-.028-.388 0-.58l.604-4.23c.063-.44.266-.846.58-1.16L13.873 3.6c.801-.801 2.1-.801 2.9 0zm-4.33 4.258l-6.825 6.825c-.008.008-.013.018-.014.029L5 18.942v.014c.003.028.03.047.057.043l4.23-.604c.01-.002.021-.007.029-.014l6.824-6.826-3.697-3.697zm2.892-2.856c-.017-.005-.035 0-.049.013l-1.429 1.429 3.697 3.697 1.43-1.429c.02-.02.02-.052 0-.072L15.36 5.015l-.023-.013z"
});

var SvgIc24Edit = function SvgIc24Edit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIc24Edit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-24-edit.57bf0d79.svg";
export { ForwardRef as ReactComponent };